import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
      <Toaster
        position="bottom-right"
        toastOptions={{
          duration: 4000,
          style: { background: '#27272a', color: '#e4e4e7', borderRadius: '0.75rem', fontSize: '0.875rem', border: '1px solid rgba(255,255,255,0.08)' },
          success: { iconTheme: { primary: '#8b5cf6', secondary: '#fafafa' } },
          error: { iconTheme: { primary: '#ef4444', secondary: '#fafafa' } },
        }}
      />
    </HelmetProvider>
  </React.StrictMode>
);
